import { Link } from "react-router-dom";

const Services = () => {
  const services = [
    {
      icon: "👥",
      title: "Workforce Management",
      description:
        "Track employee attendance, manage requests, analyze workforce productivity, and run smooth daily operations through structured insights.",
    },
    {
      icon: "🏢",
      title: "Visitor Management",
      description:
        "Digitalize and secure visitor registration, check-ins, badge printing, and real-time security monitoring at entry points.",
    },
    {
      icon: "🔒",
      title: "Security Solutions",
      description:
        "Enhance workplace security through smart access control systems, video monitoring integrations, and intelligent alert logic.",
    },
  ];

  const features = [
    {
      icon: "🚀",
      title: "Innovation",
      description:
        "Cutting-edge technology solutions designed for scale.",
    },
    {
      icon: "🔒",
      title: "Security",
      description:
        "Enterprise-grade protocols to protect vital data assets.",
    },
    {
      icon: "⚡",
      title: "Fast Delivery",
      description:
        "Swift and dependable product deployment timelines.",
    },
    {
      icon: "🎯",
      title: "Customer Focused",
      description:
        "Dedicated support engineers and custom configurations.",
    },
  ];

  return (
    <>
      {/* Services Section */}
      <section className="py-16 lg:py-24 relative overflow-hidden bg-white">
        <div className="absolute top-0 right-1/4 w-96 h-96 bg-cyan-100/30 rounded-full blur-3xl pointer-events-none -z-10"></div>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center max-w-3xl mx-auto mb-20">
            <h2 className="text-4xl md:text-5xl font-extrabold text-slate-900 tracking-tight">
              Our Services
            </h2>

            <div className="h-1 w-14 bg-cyan-500 mx-auto mt-4 rounded-full"></div>

            <p className="mt-6 text-lg text-slate-600">
              Smart technology solutions designed to elevate operational
              intelligence and secure modern businesses.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10">
            {services.map((service, index) => (
              <div
                key={index}
                className="group bg-white p-8 rounded-2xl border border-slate-200 shadow-sm hover:shadow-xl transition-all duration-300 hover:-translate-y-2"
              >
                <div className="w-14 h-14 bg-cyan-50 text-cyan-600 text-3xl rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 transition">
                  {service.icon}
                </div>

                <h3 className="text-2xl font-bold text-slate-900 mb-3 group-hover:text-cyan-600 transition">
                  {service.title}
                </h3>

                <p className="text-slate-500 leading-relaxed text-sm">
                  {service.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="py-20 bg-slate-50 border-t border-slate-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

          <div className="text-center max-w-2xl mx-auto mb-16">
            <h2 className="text-3xl font-bold text-slate-900">
              Why Choose Bytecs?
            </h2>

            <div className="h-1 w-10 bg-cyan-500 mx-auto mt-4 rounded-full"></div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {features.map((feature, index) => (
              <div
                key={index}
                className="text-center p-6 bg-white rounded-2xl border border-slate-200 shadow-sm hover:shadow-lg hover:border-cyan-200 transition"
              >
                <div className="text-4xl mb-4">{feature.icon}</div>

                <h3 className="font-bold text-lg text-slate-900 mb-2">
                  {feature.title}
                </h3>

                <p className="text-sm text-slate-500">
                  {feature.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-r from-cyan-600 to-blue-700 text-white relative overflow-hidden">
        <div className="absolute -top-24 -left-24 w-80 h-80 bg-white/10 rounded-full blur-3xl"></div>

        <div className="max-w-4xl mx-auto text-center px-4 relative z-10">
          <h2 className="text-4xl md:text-5xl font-extrabold">
            Ready To Transform Your Business?
          </h2>

          <p className="mt-6 text-cyan-100 max-w-2xl mx-auto">
            Let's discuss how Bytecs Technologies can help streamline
            operations, scale security, and accelerate digitalization.
          </p>

          <div className="mt-8">
            <Link
              to="/contact"
              className="inline-block bg-white text-cyan-600 px-8 py-4 rounded-full font-semibold hover:bg-cyan-50 transition shadow-lg hover:shadow-xl"
            >
              Talk to an Expert
            </Link>
          </div>
        </div>
      </section>
    </>
  );
};

export default Services;